import React from "react"
import { graphql } from "gatsby"

import { FaHeart } from 'react-icons/fa'

import Layout from "../components/layout"
import SEO from "../components/seo"

import kadLibrary from '../../static/images/kad-library.png'
import pokedex from '../../static/images/pokedex.png'
import flixter from '../../static/images/flixter.png'
import nomster from '../../static/images/nomster.png'
import grammable from '../../static/images/grammable.png'
import note from '../../static/images/note.png'
import splurty from '../../static/images/splurty.png'
import flickrStream from '../../static/images/flickr-stream.png'
import portfolioOne from '../../static/images/portfolioOne.png'
import '../styles/work.css'


class Work extends React.Component {
  render() {
    const { data } = this.props
    const siteTitle = data.site.siteMetadata.title

    return (
      <Layout location={this.props.location} title={siteTitle}>
        <SEO title="Work" />
        <h1 className="work-title">Work</h1>
        <h2 className="work-title">Tech + Tools</h2>
        <p>Below are some of the tools and technologies with which I've worked (I especially <FaHeart alt="love" aria-label="love" /> Ruby!):</p>

        <p id="tech-skills-content">
          <span className="tech-skills-label">Ruby</span>
          <span className="tech-skills-label">Rails</span>
          <span className="tech-skills-label">Python</span>
          <span className="tech-skills-label">Django</span>
          <span className="tech-skills-label">Flask</span>
          <span className="tech-skills-label">JavaScript</span>
          <span className="tech-skills-label">AngularJS</span>
          <span className="tech-skills-label">React</span>
          <span className="tech-skills-label">jQuery</span>
          <span className="tech-skills-label">HTML</span>
          <span className="tech-skills-label">CSS</span>
          <span className="tech-skills-label">Prometheus</span>
          <span className="tech-skills-label">Grafana</span>
          <span className="tech-skills-label">Kibana</span>
          <span className="tech-skills-label">Sentry</span>
          <span className="tech-skills-label">RabbitMQ</span>
          <span className="tech-skills-label">Redis</span>
          <span className="tech-skills-label">Github</span>
          <span className="tech-skills-label">Jenkins</span>
        </p>
        <h2>Projects</h2>
        <section id="work-content">
          <div className="app-container">
            <img className="app-image" src={pokedex} alt="Pokedex Screenshot" />

            <article className="app-description">
              <h3>Pokédex</h3>
              <div className="tech-label-container">
                <span className="tech-label">React</span>
                <span className="tech-label">APIs</span>
                <span className="tech-label">CSS</span>
              </div>
              <p>
                Integrates with the <a href="https://pokeapi.co/">PokéAPI</a> to provide Pokémon information. Inspired by the Pokémon Red and Blue games.
              </p>
              <p>
                <a href="https://pokedexapp.com/">Live Site</a> | <a href="https://github.com/amyhenning/pokedex">Code</a>
              </p>
            </article>
          </div>

          <div className="app-container">
            <img className="app-image" src={kadLibrary} alt="KAD Library Screenshot" />

            <article className="app-description">
              <h3>Korean Adoptee Library</h3>
              <div className="tech-label-container">
                <span className="tech-label">Ruby</span>
                <span className="tech-label">Rails</span>
                <span className="tech-label">jQuery</span>
                <span className="tech-label">Bootstrap</span>
                <span className="tech-label">PostgreSQL</span>
              </div>
              <p>
                An application for adoptees to submit, rate, and bookmark resources on the adoptee experience.
              </p>
              <p>
                <a href="https://kad-library.herokuapp.com/">Live Site</a> | <a href="https://github.com/amyhenning/kad-library">Code</a>
              </p>
            </article>
          </div>


          <div className="app-container">
            <img className="app-image" src={note} alt="Note Screenshot" />

            <article className="app-description">
              <h3>Note</h3>
              <div className="tech-label-container">
                <span className="tech-label">React</span>
                <span className="tech-label">Ruby</span>
                <span className="tech-label">Rails</span>
                <span className="tech-label">PostgreSQL</span>
              </div>
              <p>
                A note-taking app built with React on the front-end and using a Ruby on Rails API for the back-end. Users can tag notes, too!
              </p>
              <p>
                <a className="bottom" href="http://note-app-amy-henning.herokuapp.com/">Live Site</a> | <a href="https://github.com/amyhenning/note-app">Code</a>
              </p>
            </article>
          </div>

          <div className="app-container">
            <img className="app-image" src={flickrStream} alt="Flickr Stream Screenshot" />

            <article className="app-description">
              <h3>Flickr Stream</h3>
              <div className="tech-label-container">
                <span className="tech-label">Ruby</span>
                <span className="tech-label">Rails</span>
                <span className="tech-label">APIs</span>
                <span className="tech-label">PostgreSQL</span>
              </div>
              <p>
                Rails app that integrates with Flickr's API. Search by username or ID and return a given Flickr user's 20 most recent photos.
              </p>
              <p>
                <a href="https://flickr-stream-amy-henning.herokuapp.com/">Live Site</a> | <a href="https://github.com/amyhenning/flickr-stream">Code</a>
              </p>
            </article>
          </div>

          <div className="app-container">
            <img className="app-image" src={portfolioOne} alt="Portfolio v.1 Screenshot" />

            <article className="app-description">
              <h3>Portfolio v.1</h3>
              <div className="tech-label-container">
                <span className="tech-label">HTML</span>
                <span className="tech-label">CSS</span>
              </div>
              <p>
                My first portfolio built from scratch post-bootcamp. Hosted on Github pages.
              </p>
              <p>
                <a href="https://amyhenning.github.io">Live Site</a> | <a href="https://github.com/amyhenning/amyhenning.github.io">Code</a>
              </p>
            </article>
          </div>

          <div className="app-container">
            <img className="app-image" src={grammable} alt="Grammable Screenshot" />

            <article className="app-description">
              <h3>Grammable</h3>
              <div className="tech-label-container">
                <span className="tech-label">Ruby</span>
                <span className="tech-label">Rails</span>
                <span className="tech-label">Bootstrap</span>
                <span className="tech-label">PostgreSQL</span>
              </div>
              <p>
                Grammable is an Instagram clone built with Ruby on Rails. Built to practice test-driven development.
              </p>
              <p>
                <a href="https://grammable-amy-henning.herokuapp.com/">Live Site</a> | <a href="https://github.com/amyhenning/grammable">Code</a>
              </p>

            </article>
          </div>

          <div className="app-container">
            <img className="app-image" src={flixter} alt="Flixter Screenshot" />

            <article className="app-description">
              <h3>Flixter</h3>
              <div className="tech-label-container">
                <span className="tech-label">Ruby</span>
                <span className="tech-label">Rails</span>
                <span className="tech-label">APIs</span>
                <span className="tech-label">JavaScript</span>
                <span className="tech-label">Bootstrap</span>
                <span className="tech-label">PostgreSQL</span>
              </div>
              <p>
                A two-sided video-streaming marketplace platform, featuring credit card payments via Stripe.
              </p>
              <p>
                <a href="https://flixter-amy-henning.herokuapp.com/">Live Site</a> | <a href="https://github.com/amyhenning/flixter">Code</a>
              </p>

            </article>
          </div>

          <div className="app-container">
            <img className="app-image" src={nomster} alt="Nomster Screenshot" />

            <article className="app-description">
              <h3>Nomster</h3>
              <div className="tech-label-container">
                <span className="tech-label">Ruby</span>
                <span className="tech-label">Rails</span>
                <span className="tech-label">APIs</span>
                <span className="tech-label">Bootstrap</span>
                <span className="tech-label">PostgreSQL</span>
              </div>
              <p>
                A Yelp Clone featuring some of my favorite places to eat in Chicago. The site integrates with the Google Maps API.
              </p>
              <p>
                <a href="https://nomster-amy-henning.herokuapp.com/">Live Site</a> | <a href="https://github.com/amyhenning/nomster">Code</a>
              </p>
            </article>
          </div>

          <div className="app-container">
            <img className="app-image" src={splurty} alt="Tolkien Quote Generator Screenshot" />

            <article className="app-description">
              <h3>Tolkien Quotes</h3>
              <div className="tech-label-container">
                <span className="tech-label">Ruby</span>
                <span className="tech-label">Rails</span>
                <span className="tech-label">Rails</span>
                <span className="tech-label">jQuery</span>
                <span className="tech-label">Bootstrap</span>
                <span className="tech-label">PostgreSQL</span>
              </div>
              <p>
                I love J.R.R. Tolkien's works, so this quote generator is Tolkien-themed!                
              </p>
              <p>
                <a href="https://splurty-amy-henning.herokuapp.com/">Live Site</a> | <a href="https://github.com/amyhenning/splurty">Code</a>
              </p>
            </article>
          </div>
        </section>
      </Layout>
    )
  }
}

export default Work

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
  }
`
